"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.PreventUserSelectSansCursor = {
    userSelect: 'none',
    'WebkitUserSelect': 'none',
    'msUserSelect': 'none',
    'MozUserSelect': 'none',
};
exports.PreventUserSelect = tslib_1.__assign({}, exports.PreventUserSelectSansCursor, { cursor: 'default' });
//# sourceMappingURL=PreventUserSelect.js.map